export default __webpack_public_path__ + "static/media/fl.6146c8e0.jpg";